
import {createContext, useState} from 'react'

const Context = createContext()

export const DireccionContextProvider = ({children}) => {
 const [allDirecciones, setAllDirecciones] = useState([]);
 const [direcciones, setDirecciones] = useState([]);
 const [direccion, setDireccion] = useState({});
 const [vinculedDirecciones, setVinculedDirecciones] = useState([]);
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })
 return <Context.Provider value={{allDirecciones, setAllDirecciones, direcciones, vinculedDirecciones, setVinculedDirecciones, setDireccion, setDirecciones, direccion, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context